(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tg-before-after"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('input', function (event) {
    var range = event.target;
    if (!range || !range.classList || !range.classList.contains('tg-ba__range')) return;
    range.closest('[data-tg-ba]').style.setProperty('--pos', range.value + '%');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tg-product"]) return;
  try {
    
  document.addEventListener('change', function (event) {
    var radio = event.target;
    if (!radio || !radio.matches || !radio.matches('.tg-form input[name="id"]')) return;
    radio.form.querySelectorAll('[data-tg-card]').forEach(function (card) {
      var active = card.contains(radio);
      card.classList.toggle('is-selected', active);
      var cars = card.querySelector('[data-tg-cars]');
      if (!cars) return;
      cars.hidden = !active;
      cars.querySelectorAll('select').forEach(function (select) {
        select.disabled = !active;
      });
    });
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('[data-tg-nav]') : null;
    if (!button) return;
    var track = button.closest('.tg-gallery').querySelector('[data-tg-track]');
    track.scrollBy({ left: Number(button.dataset.tgNav) * track.clientWidth, behavior: 'smooth' });
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.classList || !form.classList.contains('tg-form')) return;
    var addons = form.querySelectorAll('[data-tg-addon]:checked');
    if (!addons.length) return;
    var main = form.querySelector('input[name="id"]:checked') || form.querySelector('[name="id"]');
    if (!main) return;
    event.preventDefault();
    var properties = {};
    form.querySelectorAll('[name^="properties["]').forEach(function (field) {
      if (field.disabled) return;
      var key = field.name.slice(11, -1);
      properties[key] = field.value;
    });
    var items = [{ id: Number(main.value), quantity: 1, properties: properties }];
    addons.forEach(function (box) {
      items.push({ id: Number(box.value), quantity: 1 });
    });
    var button = form.querySelector('.tg-atc');
    if (button) button.disabled = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add failed');
        window.location.href = root + 'cart';
      })
      .catch(function () {
        if (button) button.disabled = false;
        form.submit();
      });
  });

  (function () {
    var bars = document.querySelectorAll('[data-tg-sticky]');
    if (!bars.length || !('IntersectionObserver' in window)) return;
    bars.forEach(function (bar) {
      var target = document.querySelector('.tg-atc');
      if (!target) return;
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        bar.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
      }).observe(target);
      var link = bar.querySelector('[data-tg-sticky-btn]');
      if (link) {
        link.addEventListener('click', function (event) {
          var section = document.querySelector(link.getAttribute('href'));
          if (!section) return;
          event.preventDefault();
          section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tg-reels"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function start(video) {
      if (video.dataset.tgBound) return;
      video.dataset.tgBound = '1';
      var load = function () {
        if (!video.src) video.src = video.dataset.tgSrc;
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      };
      if (!('IntersectionObserver' in window)) return load();
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) load();
          else if (video.src) video.pause();
        });
      }, { rootMargin: '200px 0px' }).observe(video);
    }
    function scan() {
      document.querySelectorAll('video[data-tg-src]').forEach(start);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
    else scan();
    document.addEventListener('shopify:section:load', scan);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tg-video-feature"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function start(video) {
      if (video.dataset.tgBound) return;
      video.dataset.tgBound = '1';
      var load = function () {
        if (!video.src) video.src = video.dataset.tgSrc;
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      };
      if (!('IntersectionObserver' in window)) return load();
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) load();
          else if (video.src) video.pause();
        });
      }, { rootMargin: '200px 0px' }).observe(video);
    }
    function scan() {
      document.querySelectorAll('video[data-tg-src]').forEach(start);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
    else scan();
    document.addEventListener('shopify:section:load', scan);
  })();

  } catch(e) { console.error(e); }
})();
})();
